/*
 * Copyright (c) 2024. Spin in het Web B.V. Apeldoorn NL.
 * Deze software is géén open source. Het auteursrecht van deze software
 * ligt bij Spin in het Web B.V. en/of Jellybean B.V. en/of de auteur.
 * Gebruik van deze software is onderhevig aan een licentieovereenkomst.
 * www.spininhetweb.nl
 */

/*
 * Public API Surface of sihw-ngx
 *
 * Alles uit public-api-zonder-editor.ts, plus de editor-onderdelen (die quill en ngx-quill nodig hebben).
 * Een nieuw onderdeel zonder quill voeg je daar toe, niet hier.
 */

export * from './public-api-zonder-editor';
export * from './lib/editor/editor.component';
export * from './lib/edited/edited.component';
